import React, { useState, useEffect } from 'react';
import Prismic from '@prismicio/client';

import config from '../../../shared/services/config';
import PayUIcon from "../../../assets/svgs/PayU-Icon.svg";

const SignInPartnerCMS = ({
 
}) => {
  const apiEndPoint = config.get('prismicCmsHost');
  const accessToken = config.get('cmsAccessToken');
  const Client = Prismic.client(apiEndPoint, { accessToken })

  const [doc, setDocData] = useState(null);

  const fetchData = async () => {
    let UIDs = [config.get('PRISMIC_DEFAULT_SIGNUP_DOC_ID')];
    if (config.get('campaign_context'))
      UIDs = [config.get('campaign_context'), ...UIDs]
    const response = await Client.query(Prismic.Predicates.in('my.login.uid', UIDs))
    if (response) {
      setDocData(response.results[0].data)
    }
  }
  useEffect(() => {
    fetchData()
  }, []);

  const onLogoClick = () => {
    if(config.get('product') === 'PARTNER'){
      window.open(`${process.env.PARTNER_HOST}`, "_blank");  
    }
    else{
      window.open(`${process.env.PAYU_WEBSITE_HOST}`, "_blank");  
    }
  }

  return (
    <div className='cms-content pl-5'>
      {
        doc && (
          <div className='pl-5 pt-4'>
            <PayUIcon className='w-auto' onClick={onLogoClick}/>
            <h6 className='pt-5 px-5 font-weight-bold co-heading mt-5'>{doc.title[0].text}</h6>
            <div className='pt-3 px-5'>
              {doc.description.map((el, index) => 
              <li key={index} className='d-flex pb-3'>
                  <img src={el.bullet.url} width={el.bullet.dimensions.width} height={el.bullet.dimensions.height} className='w-auto'/>
                  <p className='pl-2 co-heading key-points'>{el.data[0].text}</p>
              </li>
              )}
            </div>
            <h5 className='pt-5'><span>{doc.logosheadings[0].text}</span></h5>
            <div className='pt-3'>
              <marquee style={{ width: '100%'}}>
                {doc.client_logos.map((logo, index) => 
                      <img key={index} src={logo.brand.url} className='p-2 ml-4 client-logo'/>
                )}
              </marquee>
            </div>
          </div>
        )
      }
    </div>
  )
}
export default SignInPartnerCMS;